import React from 'react';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import {FavoriteButton} from 'components/partials/favorite-button';
import {ShoppingCartButton} from 'components/partials/shopping-cart-button';
import {SendRequestButton} from 'components/partials/send-request-button';
import {GetQuotesButton} from 'components/partials/get-quotes-button';
import {ShowIf} from 'components/utils';
import style from './style.scss';

class ProductInfo extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <section className="product-info">
        <h2 className="product-title">{this.props.name}</h2>
        <p className="product-description">{this.props.description}</p>
        {
          this.props.business &&
          <div className="conpany-wrap">
            <div className="company-image-wrap">
              <UploadImage transform="crop" type="BUSINESS" width="45" height="42" image={this.props.business.logo} />
            </div>
            <p className="company-name">{this.props.business.name}</p>
            <p className="view-info">
              <Link to={`/doanh-nghiep/${this.props.business.nameSlug}`} className="view-info-link">Xem thông tin doanh nghiệp</Link>
            </p>
          </div>
        }
        <p className="product-price">Giá <span className="price">{this.props.price === 'Giá tham khảo' ? "Liên hệ" : this.props.price}</span></p>
        <div className="wrap-button">
          <ShowIf condition={parseFloat(this.props.price) > 0}>
            <ShoppingCartButton productId={this.props.id} isDetail={true} />
          </ShowIf>
          <ShowIf condition={isNaN(parseFloat(this.props.price))}>
            <SendRequestButton productId={this.props.id} isDetail={true} />
          </ShowIf>
          <GetQuotesButton productName={this.props.name}/>
          <FavoriteButton productId={this.props.id}/>
        </div>
      </section>
    );
  }
}

export default ProductInfo;



// WEBPACK FOOTER //
// ./components/product-detail/sub-view/product-info/ProductInfo.jsx